/*
 * @Author: shiguang
 * @Date: 2023-07-04 22:27:10
 * @LastEditors: yusha
 * @LastEditTime: 2023-12-28 13:38:04
 * @Description: Description
 */

import qs from 'query-string';
import { createContext } from 'react';
import { getLang } from './i18n';

/**
 * 国家及货币单位
 */
enum Site {
	/**
	 * 日本站
	 */
	JA = 'JapanStation',
	/**
	 * 韩国站
	 */
	KR = 'KoreaStation',
	/**
	 * 英国站
	 */
	UK = 'UkStation'
}

/** */
export enum Local {
	ZH = 'zh',
	/** 日文 */
	JA = 'ja',
	/** 韩文 */
	KO = 'ko',
	/** 英文 */
	EN = 'en'
}

/** */
export enum Lang {
	zh_CN = 'zh_CN',

	/** 日文 */
	ja_JP = 'ja_JP',
	/** 韩文 */
	ko_KR = 'ko_KR',
	/** 英文 */
	en_GB = 'en_GB'
}

const initLang = getLang();

/**
 * 获取站点信息
 * @returns
 */
export const getStationCode = () => {
	return Site[initLang] || Site.JA;
};

export const LocalContext = createContext(initLang);

export const getUnTranslateData = (data) => {
	return Object.entries(data).reduce((pre, cur: any) => {
		const [key, config] = cur;
		pre[key] = Object.entries(config).reduce((_pre, _cur) => {
			const [_key, _value] = _cur;
			if ('' === _value) {
				_pre[_key] = '';
			}
			return _pre;
		}, {});
		return pre;
	}, {});
};

export const mergeDataByOtherConfig = (data, otherConfig) => {
	return Object.entries(data).reduce((pre, cur: any) => {
		const [key, config] = cur;
		pre[key] = Object.entries(config).reduce((_pre, _cur) => {
			const [_key, _value] = _cur;
			if (_value === '' && otherConfig[_key]) {
				_pre[_key] = otherConfig[_key];
			} else {
				_pre[_key] = _value;
			}
			return _pre;
		}, {});
		return pre;
	}, {});
};
